import { render, staticRenderFns } from "./fuels.vue?vue&type=template&id=60b32917&scoped=true"
import script from "./fuels.vue?vue&type=script&lang=js"
export * from "./fuels.vue?vue&type=script&lang=js"
import style0 from "./fuels.vue?vue&type=style&index=0&id=60b32917&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b32917",
  null
  
)

export default component.exports